<mat-form-field floatLabel="never">
  <mat-icon matPrefix>search</mat-icon>
  <input matInput [placeholder]="placeholder" [formControl]="searchForm" />
  <mat-hint>{{ hint }}</mat-hint>
</mat-form-field>
